<template>
  <div
    class="myhome-empty-book dea-border-grey-medium"
    :class="{
      'myhome-empty-book--vertical': !isHorizontal,
      'myhome-empty-book--horizontal': isHorizontal,
      'myhome-empty-book--student': student || parent,
    }"
  >
    <div class="myhome-empty-book__content">
      <img class="myhome-empty-book__image" :src="emptyBookImage" />
      <div class="myhome-empty-book__activation">
        <slot>
          <div class="dea-heading--medium-xl myhome-empty-book__title">Attiva il tuo libro Deascuola</div>
        </slot>
        <Buttons class="dea-button--large dea-button--iconRight" icon="attiva" @click="$emit('open-activation-modal')">
          Attiva Libro
        </Buttons>
      </div>
      <div v-if="!student && !parent" class="myhome-empty-book__evaluation">
        <div class="dea-heading--medium-xl">o chiedine uno in valutazione!</div>
        <div class="myhome-empty-book__evaluation-actions">
          <Buttons
            class="dea-button--large dea-button--inline dea-button--iconRight"
            icon="copia-digitale"
            @click="$emit('open-evaluation-modal')"
          >
            Richiedi copia digitale
          </Buttons>
          <Links
            class="dea-links--pointer"
            icon="go-to"
            :href="catalogLink"
            label-class="dea-heading--medium-xs"
            :class="`dea-links--${linkColor}`"
            target="_blank"
            >Esplora il catalogo
          </Links>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";
import Buttons from "deascuola-storybook/src/components/elements/Buttons";
import emptyBookImage from "~/assets/AP_dettaglioprodotto_368_corredo.png";
import UserLinks from "~/components/books/mixins/UserLinks";

export default {
  name: "EmptyBook",
  components: { Links, Buttons },
  mixins: [UserLinks],

  props: {
    align: {
      type: String,
      default: "horizontal",
      validator: val => {
        return ["horizontal", "vertical"].indexOf(val) > -1;
      },
    },
    linkColor: {
      type: String,
      default: "",
    },
    parent: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      emptyBookImage,
    };
  },
  computed: {
    isHorizontal() {
      return this.align === "horizontal";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_empty-section"; //sass-lint:disable-line clean-import-paths

$empty-section-image-max-width: 368px;

.myhome-empty-book {
  @include empty-section;
  border: $border-bold;
  border-radius: $border-radius-large;

  &--student {
    margin-bottom: $space-x-large + $space-base;
  }

  &__activation,
  &__evaluation {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-top: $space-intermediate;

    p {
      @include media("<=s") {
        text-align: center;
      }
    }

    .dea-button {
      margin-top: $space-base;
    }
  }

  &__horizontal {
    padding: $space-large $space-x-large;
  }

  &__activation {
    @include hpadding($space-large, $space-large);

    margin-left: $space-large;
    padding-left: 0;
  }

  &__evaluation-actions {
    @include media("<m") {
      align-items: flex-start;
      flex-direction: column;
    }
    align-items: flex-end;
    display: flex;

    .dea-links {
      @include media(">m") {
        margin-left: $space-x-large;
      }

      margin-bottom: 0;
      margin-left: 0;
      margin-top: $space-x-small;
    }
  }

  &__image {
    max-width: $empty-section-image-max-width;
    width: 100%;
  }
}
</style>
